import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import config from "@/config";

export default function Header() {
  const [onlineCount, setOnlineCount] = useState(() => {
    return Math.floor(12000 + Math.random() * 3000);
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setOnlineCount((prev) => {
        const delta = Math.floor(Math.random() * 8) - 3;
        const next = prev + delta;
        return Math.min(Math.max(next, 8000), 20000);
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.header
      className="sticky top-0 z-50 flex items-center justify-between bg-background-50/80 px-4 py-3 backdrop-blur-md"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.25, 0.4, 0.25, 1], delay: 0.1 }}
    >
      <div className="flex items-center gap-2">
        <motion.span
          className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-sm font-bold text-white"
          whileHover={{ scale: 1.1, rotate: -5 }}
          whileTap={{ scale: 0.9 }}
        >
          <i className="ri-heart-3-fill" />
        </motion.span>
        <span className="text-lg font-bold tracking-tight text-foreground-50">
          <span className="text-primary-400">{config.siteTitle}</span>
        </span>
      </div>
      <div className="flex items-center gap-1.5 rounded-full bg-background-200/70 px-3 py-1.5 text-xs font-medium text-foreground-300">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-green-400" />
        </span>
        <span>
          <b className="text-foreground-100">{onlineCount.toLocaleString()}</b> 人がオンライン
        </span>
      </div>
    </motion.header>
  );
}